import { useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signOut,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
// } from "https://www.gstatic.com/firebasejs/12.10.0/firebase-auth.js";
import { getFirebaseAuth, createMicrosoftProvider } from "../lib/firebase";
import { AUTH_CONFIG } from "../config";

const TENANT_ID = "9e2cb467-7238-480d-87c7-1564b4e4a8fc";

export function useFirebaseAuth() {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);
    
  useEffect(() => {
    let unsub = null;

    (async () => {
      const auth = await getFirebaseAuth();

      // ① 永続化（リダイレクト復帰後の安定化に寄与）
      await setPersistence(auth, browserLocalPersistence);

      // ② redirect結果の取得（戻ってきた直後の結果）
      // resultが無いときは null になるだけなのでOK
      try {
        await getRedirectResult(auth);
      } catch (e) {
        console.warn("[auth] redirect error", e?.code, e?.message, e);
      }

      // ③ 認証状態の監視（ここがメイン）
      // Firebase Authが未ログイン⇒ログイン、ログイン⇒ログアウトを検知すると呼ばれる
      unsub = onAuthStateChanged(auth, (u) => {
        setUser(u || null);
        setInitializing(false);
      });
    })();

    // 画面が破棄された時に認証リスナーを解除
    return () => {
      if (unsub) unsub();
    };
  }, []);

  const login = async () => {
    const auth = await getFirebaseAuth();
    await setPersistence(auth, browserLocalPersistence);

    const provider = createMicrosoftProvider({ tenant: AUTH_CONFIG.microsoftTenantId });
    return signInWithRedirect(auth, provider);
  };

  const logout = async () => {
    const auth = await getFirebaseAuth();
    return signOut(auth);
  };

  return { user, initializing, login, logout };
}
